export function getCategoriesGroups() {
    return [
        {
            id: 1,
            mobileLeft: true,
            items: [
                {
                    id: 13,
                    keys: ['projects_spk2'],
                    label: 'Проекты',
                    value: false,
                },
                {
                    id: 21,
                    keys: ['course'],
                    label: 'Онлайн-курсы',
                    value: false,
                },
            ],
        },
        {
            id: 3,
            mobileLeft: true,
            items: [
                {
                    id: 32,
                    keys: ['progress_soft_skills'],
                    label: 'Компетенции',
                    value: false,
                },
                {
                    id: 34,
                    keys: ['testing'],
                    label: 'Тесты',
                    value: false,
                },
            ],
        },
        {
            id: 11,
            mobileLeft: false,
            items: [
                {
                    id: 111,
                    keys: ['news'],
                    label: 'Новости',
                    value: false,
                },
                {
                    id: 43,
                    keys: ['blogs'],
                    label: 'Блоги',
                    value: false,
                },
            ],
        },
        {
            id: 4,
            mobileLeft: false,
            items: [
                {
                    id: 41,
                    keys: ['success_story'],
                    label: 'Истории успеха',
                    value: false,
                },
                {
                    id: 42,
                    keys: ['gallery'],
                    label: 'Фотогалерея',
                    value: false,
                },
            ],
        },
    ];
}
